import { Mic, Brain, FileCheck2, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const steps = [
  {
    icon: Mic,
    step: "Step 1",
    title: "Record the visit",
    desc: "Press record and talk naturally with your patient. PalNote captures the entire conversation.",
  },
  {
    icon: Brain,
    step: "Step 2",
    title: "AI understands it",
    desc: "Voice AI documentation built for MSK care transcribes and understands the clinical conversation.",
  },
  {
    icon: FileCheck2,
    step: "Step 3",
    title: "Get your SOAP note",
    desc: "Receive a complete, editable SOAP note ready for your patient chart in seconds.",
  },
];

export function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="scroll-mt-24 bg-gradient-to-b from-slate-50 to-white py-24"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            How It Works
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            From conversation to chart in three steps
          </h2>
        </Reveal>

        <div className="mt-16 grid items-stretch gap-6 lg:grid-cols-[1fr_auto_1fr_auto_1fr]">
          {steps.map(({ icon: Icon, step, title, desc }, i) => (
            <div key={title} className="contents">
              <Reveal delay={i * 0.12} className="h-full">
                <div className="relative h-full overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-8 shadow-sm">
                  <span className="absolute right-5 top-4 text-6xl font-bold text-slate-100">
                    {i + 1}
                  </span>
                  <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-600 text-white shadow-lg shadow-blue-600/25">
                    <Icon className="h-7 w-7" />
                  </div>
                  <p className="relative mt-6 text-xs font-semibold uppercase tracking-wider text-blue-600">
                    {step}
                  </p>
                  <h3 className="relative mt-2 text-xl font-semibold text-slate-900">{title}</h3>
                  <p className="relative mt-2 text-sm leading-relaxed text-slate-600">{desc}</p>
                </div>
              </Reveal>
              {i < steps.length - 1 && (
                <div className="hidden items-center justify-center lg:flex">
                  <ArrowRight className="h-7 w-7 text-blue-300" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
